module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', {
    staticClass: "w5-form-wrapper"
  }, [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger font-size-90 margin-top-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData.title)))]), _vm._v(" "), (_vm.crud === 'operation' && _vm.action === 'create' && _vm.$store.state.user_type === 'client') ? _c('div', {
    staticClass: "w5-block-bordered"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('operation/bonus_information')),
      expression: "localeFtc('operation/bonus_information')"
    }],
    staticClass: "w5-block-bordered-text"
  })]) : _vm._e(), _vm._v(" "), (_vm.showAdditionalInfo) ? _c('div', {
    staticClass: "w5-form-additional-info"
  }, [(_vm.formInfo.max) ? _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/available_to_order')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.max))]), (_vm.formInfo.for) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.formInfo.cost) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("ftc")('servicetype/cost')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.formInfo.cost))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  }), (_vm.formInfo.period) ? _c('span', [_vm._v(" / " + _vm._s(_vm._f("ftc")(_vm.formInfo.period)))]) : _vm._e(), (_vm.crud === 'disks' && _vm.formInfo.for) ? _c('span', [_vm._v(" / 1 " + _vm._s(_vm._f("ftc")(_vm.formInfo.for)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "w5-from",
    class: {
      'form-with-divider': _vm.isFormWithDivider
    },
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": (_vm.form_Loading || _vm.isFormLocked) && !_vm.outerDiskRequestType
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row),
          'with-number-divider': _vm.isFormWithNumberDivider,
          'divider-field': _vm.isDividerField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "countVisibleFieldsInRow": _vm.countVisibleFieldsInRow(row),
          "objID": _vm.id,
          "crud": _vm.crud,
          "action": _vm.action,
          "Field": field,
          "listBlockToOut": _vm.crud === 'domains' && field._field_name === 'plan_id' ? false : true,
          "linkHint": _vm.LinkHintForField(field, _vm.linkHint),
          "groupField": (_vm.crud === 'vds' || _vm.crud === 'certificate' || _vm.crud === 'domains') && _vm.action === 'create' && field._field_name === 'plan_id' ? _vm.findField('plan_group_id') : null,
          "backupField": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'template_id' ? _vm.findField('backup_id') : null,
          "accountField": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'template_id' ? _vm.findField('account_id') : null,
          "nameField": _vm.crud === 'domains' && _vm.action === 'create' && field._field_name === 'plan_id' ? _vm.findField('name') : null,
          "actionField": _vm.crud === 'domains' && _vm.action === 'create' && field._field_name === 'plan_id' ? _vm.findField('set_action') : null,
          "planField": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'backup_auto' ? _vm.findField('plan_id') : null,
          "planParams": _vm.crud === 'vds' && _vm.action === 'create' && field._field_name === 'backup_auto' ? _vm.params : null,
          "bigButton": _vm.showPayButton && field._field_name === 'fake_1_1',
          "bigButtonTitle": _vm.showPayButton && field._field_name === 'fake_1_1' ? 'operation/pay' : null,
          "bigButtonHandler": _vm.showPayButton && field._field_name === 'fake_1_1' ? _vm.onClientCreateOperation : null,
          "bigButtonEnabled": _vm.showPayButton && field._field_name === 'fake_1_1' && _vm.isSubmitButtonEnabled,
          "linkButton": _vm.showPayButton && field._field_name === 'fake_1_2',
          "linkButtonTitle": _vm.showPayButton && field._field_name === 'fake_1_2' ? 'paymentauto/update_title' : null,
          "linkButtonUrl": '/paymentauto/create',
          "linkButtonVisible": _vm.showAutoPaymentButton,
          "formFields": _vm.crud === 'vds' && _vm.action === 'create' ? _vm.formData.fields : null,
          "progress": _vm.crud === 'iso' && _vm.action === 'create' && (field._field_name === 'download' || field._field_name === 'library') ? _vm.isoFormFileProgress : null,
          "diskTypeValue": _vm.crud === 'disks' && field._field_name === 'quantity' ? _vm.outerDiskTypeValue : null
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChanged(field)
          },
          "abortUpload": function($event) {
            return _vm.fieldChanged(field)
          },
          "uploadFinished": _vm.onUploadFinished,
          "blur": function($event) {
            return _vm.onBlur(field)
          },
          "focus": function($event) {
            return _vm.onFocus(field)
          },
          "blockFormButton": _vm.blockFormButton,
          "unblockFormButton": _vm.unblockFormButton,
          "cropCoords": _vm.cropCoords,
          "enterKeyDown": _vm.onEnterKeyDown,
          "deleteFileValue": _vm.deleteFileValue,
          "operationNextStep": _vm.onClientCreateOperation,
          "answerTemplateDialog": _vm.showTemplateDialog,
          "event_Input": _vm.onTextEvent,
          "groupChanged": _vm.onGroupChanged,
          "domainName": _vm.onDomainName,
          "templateTab": _vm.onTemplateTab,
          "createBackup": _vm.createBackup,
          "deleteSavedPayment": _vm.onDeleteSavedPayment,
          "freePort": _vm.onFreePort,
          "value2FA": _vm.on2FAValue,
          "isoUploadError": _vm.onIsoUploadError,
          "isoUploadCanceled": _vm.onIsoUploadCanceled,
          "isoUploadFinished": _vm.onIsoUploadFinished,
          "outerDiskTypeChanged": _vm.onOuterDiskTypeChanged,
          "autoprolongWarning": _vm.onAutoprolongWarning,
          "params": _vm.onParams
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.crud === 'options') ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    staticClass: "w5-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearSettings),
      expression: "clearSettings"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": "clearSettings"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearSettings) ? _vm._i(_vm.clearSettings, null) > -1 : (_vm.clearSettings)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearSettings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clearSettings = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.clearSettings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clearSettings = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline-flex",
      "height": "3em",
      "line-height": "1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.clearSettings = !_vm.clearSettings
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/clear_settings')) + "\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t \n\t\t\t\t\t"), _c('notice', {
    attrs: {
      "text": _vm._f("ftc")('main/clear_settingst_notice'),
      "index": _vm.clearSettings
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.crud === 'options') ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    staticClass: "w5-field"
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-weight": "400",
      "margin-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('notifier/choose_track')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "notifier-track-wrapper"
  }, [_c('span', {
    staticClass: "notifier-track switcher"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.whatVolume ? 'volume-up' : 'volume-mute',
      "fixed-width": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setVolume($event)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 0 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(0)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 1 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(1)
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 2 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(2)
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "notifier-track",
    class: _vm.trackNo === 3 ? 'selected' : false,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setTrack(3)
      }
    }
  }, [_vm._v("4")])])])]) : _vm._e(), _vm._v(" "), (_vm.crud === 'vds' && _vm.action === 'create' && _vm.formData && _vm.formData.fields && _vm.linkHint && !_vm.linkHintShowIf && _vm.activeCreateVdsTemplateTab !== 'backup') ? _c('div', {
    staticClass: "w5-info-link vds-create"
  }, [_c('font-awesome-icon', {
    staticClass: "margin-right-6",
    attrs: {
      "icon": "info-circle"
    }
  }), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : (_vm.linkHint && _vm.linkHint.length && _vm.linkHint[0].afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint[0].afterText)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.crud !== 'operation' || _vm.action !== 'create' || _vm.$store.state.user_type !== 'client') ? _c('div', {
    ref: "button_wrapper",
    staticClass: "w5-field form-button",
    class: {
      'margin-top-30': _vm.isFormWithDivider
    }
  }, [_c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-primary w5-button-save",
    class: {
      hidden: _vm.form_Loading && !_vm.outerDiskRequestType, fxd: _vm.isFormButtonFixed
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonBlock > 0 && !_vm.outerDiskRequestType ? 'disabled' : false
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.action === 'update' || _vm.action === 'alerts' || _vm.action === 'links' ? 'main/save' : 'main/create')) + "\n\t\t\t\t")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.formData && _vm.formData.fields && _vm.linkHint && _vm.linkHint.position === 'bottom') ? _c('div', {
    staticClass: "w5-info-link margin-right-10 margin-top-20"
  }, [(_vm.linkHintShowIf) ? [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.linkHint.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkHint.title)))])] : _c('font-awesome-icon', {
    staticClass: "margin-right-6",
    attrs: {
      "icon": "info-circle"
    }
  }), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoneyModal),
      expression: "showMoneyModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideMoneyModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.moneyModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideMoneyModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-danger font-size-90 margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.moneyModalText),
      expression: "moneyModalText"
    }],
    staticClass: "padding-0-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.moneyModalAddButton !== '') ? _c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.continueSubmit
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.moneyModalAddButton)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.goToMoney
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/replenishment')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateModal),
      expression: "showTemplateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": _vm.filterModalContainers
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('text/find_templates')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textSearch', {
    ref: "textSearchTemplateDialog",
    attrs: {
      "Field": _vm.templateField
    },
    on: {
      "textSelected": _vm.templateChoiced
    }
  })], 1)])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSshKeyModal),
      expression: "showSshKeyModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideSshKeyModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container wide",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('sshkey/create_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideSshKeyModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.sshKeyFields && _vm.sshKeyFields.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.sshKeyFields.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleSshKeyField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleSshKeyField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "sshkey",
          "action": "create",
          "Field": field
        },
        on: {
          "blur": function($event) {
            return _vm.onBlurSshKey(field)
          },
          "focus": function($event) {
            return _vm.onFocusSshKey(field)
          },
          "enterKeyDown": _vm.onEnterKeyDownSshKey
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.sshKeyCreateBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('sshkey/create_button')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPayerDialogModal),
      expression: "showPayerDialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/payer')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePayerDialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('payer/new_alert')),
      expression: "localeFtc('payer/new_alert')"
    }],
    staticClass: "padding-0-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.goToCreatePayer
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('payer/create_title')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deleteModalText),
      expression: "deleteModalText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteModalCallback
    }
  }, [_vm._v(_vm._s(_vm.deleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGeneralDialog),
      expression: "showGeneralDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.generalDialogTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideGeneralDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.generalDialogText),
      expression: "generalDialogText"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    class: {
      'btn-submit-danger': _vm.generalDialogButtonStyle === 1
    },
    attrs: {
      "disabled": _vm.generalDialogTimer && _vm.generalDialogTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.generalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm.generalDialogButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2FADialogModal),
      expression: "show2FADialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.fields2FA && _vm.fields2FA.__value ? 'twofa/delete_title' : 'twofa/create_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fields2FA && _vm.fields2FA.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.fields2FA.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row v-center': _vm.isVisibleField(row)
      }
    }, [_vm._l((row), function(field) {
      return [(field.type !== 'image') ? _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "twofa",
          "action": "create",
          "Field": field
        },
        on: {
          "blur": function($event) {
            return _vm.onBlurSshKey(field)
          },
          "focus": function($event) {
            return _vm.onFocusSshKey(field)
          },
          "enterKeyDown": _vm.submit2FAForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _c('img', {
        staticClass: "qr",
        attrs: {
          "src": field.value,
          "title": field.title
        }
      })]
    })], 2) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(!_vm.fields2FA || !_vm.fields2FA.__value) ? _c('div', {
    staticClass: "hidden-xs pull-left"
  }, [_c('a', {
    staticClass: "app-link google-play",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank",
      "rel": "nofollow noopener"
    }
  }, [_vm._v("Google Play")]), _vm._v(" "), _c('a', {
    staticClass: "app-link app-store",
    attrs: {
      "href": "https://apps.apple.com/ru/app/google-authenticator/id388497605",
      "target": "_blank",
      "rel": "nofollow noopener"
    }
  }, [_vm._v("App Store")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.submit2FAForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check')))])])])])])]), _vm._v(" "), _c('audio', {
    ref: "audioNotif_00",
    attrs: {
      "src": "/static/snd/notif.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_01",
    attrs: {
      "src": "/static/snd/notif01.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_02",
    attrs: {
      "src": "/static/snd/notif02.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_03",
    attrs: {
      "src": "/static/snd/notif03.mp3"
    }
  })] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479340fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/Update.vue
// module id = 670
// module chunks = 0